<div class="loading">
  <img src="assets/img/menu7.png" />
  <div class="text" [class.ellipsis]="text">{{ text }}</div>
</div>
